export default {
  'Custom': 'Aangepaste',
  'Original': 'Origineel',
  'Resolution': 'Resolutie',
  'Frame rate': 'Beeldsnelheid',
  'The higher the frame rate, the smoother the animation': 'Hoe hoger de framerate, hoe vloeiender de animatie.',
  'Start': 'Begin',
  'End': 'Einde',
  'Create GIF': 'GIF maken',
  'Download GIF': 'GIF downloaden',
  'Create A New One': 'Een nieuwe maken',
  'Remake GIF': 'GIF opnieuw maken',
  'HitPaw Video to GIF Online': 'HitPaw Video naar GIF Online',
  'Upload and convert video to GIF without any difficulty': 'Upload en converteer video naar GIF zonder enige moeite',
}